export const kiemKe = {
  sections: {
    list: { title: 'Stock take' },
    detail: { title: 'Stock take detail' },
  },
  titles: { add: 'New stock take' },
  columns: {
    code: 'Document code',
    chiNhanh: 'Branch',
    summary: 'Summary',
    status: 'Status',
    time: 'Time',
    ngayCanBang: 'Balanced at',
    tongSlThucTe: 'Actual qty',
    tongGiaTriThucTe: 'Actual value',
    tongChenhLech: 'Total variance',
    slLechTang: 'Qty increase',
    slLechGiam: 'Qty decrease',
    note: 'Note',
    creator: 'Created by',
    maPhieuKho: 'Stock voucher',
  },
  fields: {
    code: 'Code',
    chiNhanh: 'Branch',
    time: 'Time',
    note: 'Note',
    status: 'Status',
    creator: 'Created by',
    lines: 'Items',
    product: 'Product',
    productSearch: 'Search code or name...',
    tonKho: 'On hand',
    soLuongThucTe: 'Actual qty',
    soLuongLech: 'Variance',
    tongChenhLech: 'Total variance',
    slLechTang: 'Qty increase',
    slLechGiam: 'Qty decrease',
    tongGiaTriThucTe: 'Actual value',
    ngayCanBang: 'Balanced at',
    actions: 'Actions',
    maHangHoa: 'Item code',
    tenHangHoa: 'Item name',
    donViTinh: 'UOM',
    tonKhoHienTai: 'On-hand',
    thucTe: 'Actual',
    slLech: 'Variance qty',
    donGiaVon: 'Cost price',
    giaTriLech: 'Variance value',
    serialImei: 'Serial/IMEI',
    dateSanPham: 'Product date',
    lyDoKiemKe: 'Stock-take reason',
    lineNote: 'Note',
  },
  form: {
    sectionHeader: 'Voucher info',
    sectionLines: 'Stock-take lines',
    maPhieu: 'Code',
    maPhieuAuto: 'Auto-generated on save',
    thoiGian: 'Time',
    note: 'Note',
    maSp: 'Item code',
    tenSp: 'Item name',
    donViTinh: 'UOM',
    tonKho: 'On-hand',
    soLuongThucTe: 'Actual',
    soLuongLech: 'Variance qty',
    giaVon: 'Cost price',
    giaTriLech: 'Variance value',
    serialImei: 'Serial/IMEI',
    dateSanPham: 'Product date',
    lyDoKiemKe: 'Stock-take reason',
    lineNote: 'Note',
    productSearch: 'Search item code or name',
    save: 'Save',
    lineCount: '{count} item(s)',
    tongSoMatHang: 'Items',
    tongSlThucTe: 'Total actual qty',
    tongChenhLech: 'Total variance qty',
    tongGiaTriLech: 'Total variance value',
  },
  detailTabs: {
    chung: 'Overview',
    generalInfo: 'Info',
    chiTietHang: 'Line items',
  },
  status: {
    phieuTam: 'Draft',
    daCanBang: 'Balanced',
    daHuy: 'Cancelled',
    daXoa: 'Deleted',
  },
  actions: {
    addLine: 'Add line',
    complete: 'Complete',
    cancelVoucher: 'Cancel',
    importExcel: 'Import Excel',
    exportExcel: 'Export Excel',
    downloadTemplate: 'Download template',
    copy: 'Copy voucher',
    dongY: 'Agree',
  },
  formImport: {
    title: 'Import stock-take items from Excel',
    confirmTitle: 'Confirm stock-take item list',
    errorTitle: 'Invalid Excel file',
    errorHint: 'Please choose a file that matches the template.',
    description: 'Choose an Excel file (Item code, Quantity), review the list, then confirm to apply to the detail table.',
    chooseFile: 'Choose file',
    confirm: 'Confirm list',
    addValidLines: 'Add valid lines ({count})',
    previewSummary: 'Matched {matched}/{total} rows',
    colStatus: 'Status',
    statusOk: 'Matched',
    statusMissing: 'Not found',
    noSheet: 'The file has no data sheet.',
    noData: 'The file has no valid item rows.',
    needMatched: 'No matched item codes to apply.',
    allUnmatched: 'No item codes matched ({total} rows).',
    someUnmatched: '{count} rows not found — skipped.',
    applySuccess: 'Applied {success}/{total} rows to the voucher.',
  },
  aria: {
    columnPicker: 'Choose visible columns',
  },
  filter: {
    searchPlaceholder: 'Search by stock take code...',
    trangThai: 'Status',
    nguoiTao: 'Created by',
    tuNgay: 'From date',
    denNgay: 'To date',
    sortDir: 'Order',
    asc: 'Ascending',
    desc: 'Descending',
  },
  filters: {
    all: 'All',
    fromDate: 'From',
    toDate: 'To',
    dateRangePlaceholder: 'Select date range',
    dateSection: 'Time',
    statusSection: 'Status',
    peopleSection: 'Created by',
    locChung: 'General filter',
    maPhieu: 'Voucher code',
    maHangHoa: 'Item code',
    tenHangHoa: 'Item name',
  },
  placeholders: {
    formTitle: 'Create / edit stock take',
    formBody: 'Enter header and items to count.',
    codeAuto: 'Leave blank for auto KK code',
  },
  canBangLo: {
    title: 'Allocate lots / IMEI for balancing',
    hint: 'Lot / IMEI-tracked items have differences: enter lots / IMEI for the surplus (inbound voucher) and pick the missing lots / IMEI (outbound voucher).',
    du: 'Surplus {qty} — added to the adjustment inbound voucher',
    thieu: 'Shortage {qty} — pick lots / IMEI for the adjustment outbound voucher',
    maLo: 'Lot / IMEI',
    hanSuDung: 'Expiry date',
    tonLo: 'Lot stock',
    soLuong: 'Quantity',
    themDong: 'Add lot / IMEI',
    daPhanBo: 'Allocated {done} / {total}',
    canMaLo: 'Enter a lot / IMEI code for every surplus row.',
    chuaDu: 'Item {ma}: allocation must total {total}.',
    vuotTon: 'Item {ma}: lot {lo} only has {ton}.',
    xacNhan: 'Balance',
    huy: 'Close',
    loadError: 'Failed to load lots.',
  },
  messages: {
    loadError: 'Failed to load stock take list.',
    soKhongDuocAm: 'Actual quantity cannot be negative.',
    deleteSuccess: 'Stock take deleted.',
    createSuccess: 'Stock take created.',
    updateSuccess: 'Stock take updated.',
    completeSuccess: 'Stock take completed and inventory balanced.',
    cancelSuccess: 'Stock take cancelled.',
    importSuccess: 'Excel import succeeded.',
    copySuccess: 'Stock take copied.',
    noData: 'No stock take documents.',
    noLines: 'No line items.',
    listSummary: '{count} document(s) total',
    needMaSp: 'Select an item code for the added line.',
    needLinesToComplete: 'Stock take has no items to balance.',
    needSoLuongThucTe:
      'Enter actual quantity for every item before balancing ({count} missing: {mas}).',
    confirmComplete: 'Complete voucher {name}? Inventory will be balanced.',
    confirmCompleteWarn: 'This will create adjustment inbound/outbound vouchers and update stock.',
    confirmCompleteHint: 'Pick the stock-take date/time again — it becomes the inbound/outbound voucher date.',
    confirmCancelVoucher: 'Cancel voucher {name}? This cannot be undone.',
    confirmCancelDaCanBang:
      'Cancel voucher {name}? Related adjustment stock vouchers will be cancelled and inventory reverted.',
  },
}
